import queryString from 'query-string';
import { generatePath, Redirect } from 'react-router-dom';
import { useMemo } from 'react';
import { ROUTES } from 'config/routes';
import { actions } from 'pages/documents_v2/config/views';

export function Share() {
    const url = useMemo(() => {
        const { query } = queryString.parseUrl(window.location.href);

        const path = generatePath(ROUTES.documents.editArea, {
            documentId: query.d,
            view: actions.VIEW,
            areaId: query.a,
        });

        return queryString.stringifyUrl({
            url: path,
            query: {
                highlightBlock: query.b,
            },
        });
    }, []);

    return <Redirect to={url} />;
}
